var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-icon-info-circle',{attrs:{"id":_vm.id}}),_c('b-popover',{attrs:{"target":_vm.id,"placement":"righttop","triggers":"hover focus","content":_vm.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }